<template>
  <a :href="url"><slot /></a>
</template>

<script>
import config from '@/config'
const urlMap = {
  shop: config.path.shopUrl
}
export default {
  name: 'OutLink',
  props: {
    path: String,
    type: {
      validator: value => ['shop'].indexOf(value) !== -1,
      default: 'shop'
    }
  },
  data() {
    return {
      url: urlMap[this.type] + this.path
    }
  }
}
</script>
